import { render, staticRenderFns } from "./puilList.vue?vue&type=template&id=c856a986&scoped=true"
import script from "./puilList.vue?vue&type=script&lang=js"
export * from "./puilList.vue?vue&type=script&lang=js"
import style0 from "./puilList.vue?vue&type=style&index=0&id=c856a986&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c856a986",
  null
  
)

export default component.exports